import { inject, Injectable, Injector } from '@angular/core';
import { Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { setDeserializedAppState } from 'Angular/state/app-state/app-state.actions';

import { AppStateService } from 'Angular/services/app-state.service';

@Injectable({ providedIn: 'root' })
export class AgentLinkNavigatorService {
    private readonly router = inject(Router);

    private readonly store = inject(Store);

    // Look up AppStateService lazily — it depends on ActivatedRoute, which
    // pages without a router don't provide, so eager injection would crash
    // the agent panel on those pages.
    private readonly injector = inject(Injector);

    async navigateToParams(params: Params, fallbackHref: string): Promise<void> {
        try {
            // If the page uses App State, dispatch state directly so its
            // URL↔store cascade does the single canonical history push.
            // Otherwise navigate — no cascade means one push is back-safe.
            const appStateService = this.tryGetAppStateService();
            if (appStateService && appStateService.urlParamKeys.length > 0) {
                const deserializedAppState = appStateService.deserialize(params);
                this.store.dispatch(setDeserializedAppState({ deserializedAppState }));
            } else {
                await this.router.navigate([], {
                    queryParams: params,
                    queryParamsHandling: 'merge',
                });
            }
        } catch {
            window.location.href = fallbackHref;
        }
    }

    private tryGetAppStateService(): AppStateService | null {
        try {
            return this.injector.get(AppStateService);
        } catch {
            return null;
        }
    }
}
